import { Routes } from '@angular/router';
import { productGuard } from 'app/core/guards/product.guard';

export const insightRoutes: Routes = [
    {
        path: 'dashboard/index',
        title: 'Pulse - Home',
        loadComponent: () =>
            import('app/products/bi/dashboards/index/index.component').then(
                m => m.IndexComponent
            ),
    },
    {
        path: 'dashboard/docs',
        title: 'Pulse - Docs',
        loadComponent: () =>
            import('app/products/bi/dashboards/docs/docs.component').then(
                m => m.DocsComponent
            ),
    },
    {
        path: 'dashboard/forum',
        loadComponent: () =>
            import('app/products/bi/dashboards/forum/forum.component').then(
                m => m.ForumComponent
            ),
    },
    {
        path: 'dashboard/leaderboard',
        loadComponent: () =>
            import('app/products/bi/dashboards/leaderboard/leaderboard.component').then(
                m => m.LeaderboardComponent
            ),
    },
    {
        path: 'dashboard/achievments',
        loadComponent: () =>
            import('app/main/dashboard-header-nav/achievements/achievements.view.component').then(
                m => m.AchievementsViewComponent
            ),
    },
    {
        path: 'dashboard/radisson-academy',
        title: 'Radisson Academy',
        loadComponent: () =>
            import('app/products/bi/dashboards/radisson-academy/radisson-academy.component').then(
                m => m.RadissonAcademyComponent
            ),
    },
    {
        path: 'dashboard/mobile-app-docs',
        title: 'Mobile App Docs',
        loadComponent: () =>
            import('app/products/bi/dashboards/mobile-app-docs/mobile-app-docs.component').then(
                m => m.MobileAppDocsComponent
            ),
    },
    {
        path: 'dashboard/million-video-docs',
        title: '1M Video Docs',
        loadComponent: () =>
            import('app/products/bi/dashboards/million-video-docs/million-video-docs.component').then(
                m => m.MillionVideoDocsComponent
            ),
    },
    {
        path: 'dashboard/daily-digest',
        title: 'Pulse - Daily Digest',
        canActivate: [productGuard('insight', 'pro')],
        loadComponent: () =>
            import('app/products/productivity/dashboards/daily-digest/daily-digest.component').then(
                m => m.DailyDigestComponent
            ),
    },
    // RevOps
    {
        path: 'dashboard/pace-report',
        title: 'Pace Report',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/revops/pace-report/pace-report.component').then(
                m => m.PaceReportComponent
            ),
    },
    {
        path: 'dashboard/rhg-marketshare',
        title: 'Market Share',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/revops/rhg-marketshare/rhg-marketshare.component').then(
                m => m.RhgMarketshareComponent
            ),
    },
    {
        path: 'dashboard/forecast-accuracy',
        title: 'Forecast Accuracy',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/revops/forecast-accuracy/forecast-accuracy.component').then(
                m => m.ForecastAccuracyComponent
            ),
    },
    {
        path: 'dashboard/room-type',
        title: 'Room Type',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/revops/room-type/room-type.component').then(
                m => m.RoomTypeComponent
            ),
    },
    {
        path: 'dashboard/system-contribution2',
        title: 'System Contribution',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/revops/system-contribution2/system-contribution2.component').then(
                m => m.SystemContribution2Component
            ),
    },
    {
        path: 'dashboard/commercial-report',
        title: 'Commercial Report',
        loadComponent: () =>
            import('app/products/bi/dashboards/revops/commercial-report/commercial-report.component').then(
                m => m.CommercialReportComponent
            ),
    },
    {
        path: 'dashboard/system-contribution-models',
        title: 'System Contribution Models',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/revops/system-contribution-models/system-contribution-models.component').then(
                m => m.SystemContributionModelsComponent
            ),
    },
    {
        path: 'dashboard/channel-mix',
        title: 'Channel Mix',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/revops/channel-mix/channel-mix.component').then(
                m => m.ChannelMixComponent
            ),
    },
    {
        path: 'dashboard/segment-mix',
        title: 'Segment Mix',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/revops/segment-mix/segment-mix.component').then(
                m => m.SegmentMixComponent
            ),
    },
    {
        path: 'dashboard/feeder-market',
        title: 'Feeder Market',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/revops/feeder-market/feeder-market.component').then(
                m => m.FeederMarketComponent
            ),
    },
    {
        path: 'dashboard/cost-acquisition',
        title: 'Cost Acquisition',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/revops/cost-acquisition/cost-acquisition.component').then(
                m => m.CostAcquisitionComponent
            ),
    },
    {
        path: 'dashboard/fc-evo',
        title: 'Forecast Evolution',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/revops/forecast-evolution/forecast-evolution.component').then(
                m => m.FcEvoComponent
            ),
    },
    {
        path: 'dashboard/fc-evo-V2',
        title: 'Forecast Evolution Manuelito',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/revops/forecast-evolution-V2/forecast-evolution-V2.component').then(
                m => m.FcEvoV2Component
            ),
    },
    {
        path: 'dashboard/ota-v2',
        title: 'Rate Shopper',
        canActivate: [productGuard('insight', 'rate')],
        loadComponent: () =>
            import('app/products/bi/dashboards/revops/ota_v2/ota_v2.component').then(
                m => m.OtaV2Component
            ),
    },
    {
        path: 'dashboard/pickup',
        title: 'Pickup',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/revops/pickup/pickup.component').then(
                m => m.PickupComponent
            ),
    },
    {
        path: 'dashboard/agency-360',
        title: 'Agency 360',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/revops/agency-360/agency-360.component').then(
                m => m.Agency360Component
            ),
    },
    {
        path: 'dashboard/brand-com',
        title: 'Brand Web Analytics',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/revops/brand-com/brand-com.component').then(
                m => m.BrandComComponent
            ),
    },
    {
        path: 'dashboard/pulse-pivot-v2',
        title: 'Pulse Pivot',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/revops/pivot2/pulse-pivot.page').then(
                m => m.PulsePivotPage
            ),
    },
    {
        path: 'dashboard/corporate-pickup',
        title: 'Corporate Pickup',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/revops/corporate-pickup/corporate-pickup.component').then(
                m => m.CorporatePickupComponent
            ),
    },
    {
        path: 'dashboard/rate-code-production',
        title: 'Rate Code Production',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/revops/rate-code-production/rate-code-production.component').then(
                m => m.RateCodeComponent
            ),
    },
    {
        path: 'dashboard/events-calendar',
        title: 'Events Calendar',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/events/events.component').then(
                m => m.EventsDashboardComponent
            ),
    },
    {
        path: 'dashboard/owner-executive',
        title: 'Owner Executive',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/revops/owner-executive/owner-executive.component').then(
                m => m.OwnerExecutiveComponent
            ),
    },

    // Distribution
    {
        path: 'dashboard/demand-360',
        title: 'Demand 360',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/distribution/demand-360/demand-360.component').then(
                m => m.Demand360Component
            ),
    },

    // Sales & Meetings
    {
        path: 'dashboard/sp-executive',
        title: 'SP Executive',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/sales-meetings/sp-executive/sp-executive.component').then(
                m => m.SPExecutiveComponent
            ),
    },
    {
        path: 'dashboard/sp-executive-v2',
        title: 'SP Executive V2',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/sales-meetings/sp-executive-V2/sp-executive-V2.component').then(
                m => m.SPExecutiveV2Component
            ),
    },
    {
        path: 'dashboard/me-intel',
        title: 'M&E Intel',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/sales-meetings/me-intel/me-intel.component').then(
                m => m.MEIntelComponent
            ),
    },
    {
        path: 'dashboard/me-leads',
        title: 'M&E Leads',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/sales-meetings/me-leads/me-leads.component').then(
                m => m.MELeadsComponent
            ),
    },
    {
        path: 'dashboard/me-space',
        title: 'M&E Space',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/sales-meetings/me-space/me-space.component').then(
                m => m.MESpaceComponent
            ),
    },
    {
        path: 'dashboard/me-connectivity',
        title: 'M&E Connectivity',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/sales-meetings/me-connectivity/me-connectivity.component').then(
                m => m.MEConnectivityComponent
            ),
    },
    {
        path: 'dashboard/me-demand',
        title: 'M&E Demand',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/sales-meetings/me-demand/me-demand.component').then(
                m => m.MEDemandComponent
            ),
    },
    {
        path: 'dashboard/me-cxl',
        title: 'M&E Lost Report',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/sales-meetings/me-cxl/me-cxl.component').then(
                m => m.MECxlComponent
            ),
    },
    {
        path: 'dashboard/account-portfolio',
        title: 'Account Portfolio',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/sales-meetings/account-portfolio/account-portfolio.component').then(
                m => m.AccountPortfolioComponent
            ),
    },
    {
        path: 'dashboard/industry-report',
        title: 'Industry Report',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/sales-meetings/industry-report/industry-report.component').then(
                m => m.IndustryReportComponent
            ),
    },
    {
        path: 'dashboard/account-manager',
        title: 'Account Manager',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/sales-meetings/account-manager/account-manager.component').then(
                m => m.AccountManagerComponent
            ),
    },
    {
        path: 'dashboard/me-productivity',
        title: 'M&E Productivity',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/sales-meetings/me-productivity/me-productivity.component').then(
                m => m.MeProductivityComponent
            ),
    },
    {
        path: 'dashboard/campaign-promotion-overview',
        title: 'Campaign Promotion Overview',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/sales-meetings/campaign-promotion/campaign-promotion.component').then(
                m => m.CampaignPromotionComponent
            ),
    },

    // Finance & Operations
    {
        path: 'dashboard/operational-report',
        title: 'Operational Report',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/finance/operational-report/operational-report.component').then(
                m => m.OperationalReportComponent
            ),
    },
    {
        path: 'dashboard/operational-report-lhg',
        title: 'Operational Report',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/finance/operational-report-lhg/operational-report-lhg.component').then(
                m => m.OperationalReportLhgComponent
            ),
    },
    {
        path: 'dashboard/quality-report',
        title: 'Quality Report',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/operations/quality-report/quality-report.component').then(
                m => m.QualityReportComponent
            ),
    },
    {
        path: 'dashboard/quality-report-lhg',
        title: 'LHG Quality Report',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/operations/quality-report-lhg/quality-report-lhg.component').then(
                m => m.QualityReportLhgComponent
            ),
    },
    {
        path: 'dashboard/quality-review-pro',
        title: 'Quality Report',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/operations/quality-review-pro/quality-review-pro.component').then(
                m => m.QualityReviewProComponent
            ),
    },
    {
        path: 'dashboard/loyalty',
        title: 'Loyalty',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/operations/loyalty/loyalty.component').then(
                m => m.LoyaltyComponent
            ),
    },

    // Presentations
    {
        path: 'dashboard/revco_v2',
        title: 'RevCo',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/presentations/revco2/revco2.component').then(
                m => m.RevCo2Component
            ),
    },
    {
        path: 'dashboard/area_performance',
        title: 'Area Performance',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/presentations/area-performance/area-performance.component').then(
                m => m.AreaPerformanceComponent
            ),
    },
    {
        path: 'dashboard/revgen',
        title: 'RevGen',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/presentations/revgen/revgen.component').then(
                m => m.RevGenComponent
            ),
    },
    {
        path: 'dashboard/commercial_review',
        title: 'Commercial Review',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/presentations/commercial-review/commercial-review.component').then(
                m => m.CommercialReviewComponent
            ),
    },
    {
        path: 'dashboard/commercial_review_me',
        title: 'Commercial Review M&E',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/presentations/commercial-review-me/commercial-review-me.component').then(
                m => m.CommercialReviewMeComponent
            ),
    },
    {
        path: 'dashboard/revgen-lhg',
        title: 'RevGen',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/presentations/revgenlhg/revgenlhg.component').then(
                m => m.RevGenLhgComponent
            ),
    },
    {
        path: 'dashboard/account-review',
        title: 'Account Review',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/presentations/account-review/account-review.component').then(
                m => m.AccountReviewComponent
            ),
    },

    // Data Control
    {
        path: 'dashboard/import-control',
        title: 'Import Control',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/data-control/import-control/import-control.component').then(
                m => m.ImportControlComponent
            ),
    },
    {
        path: 'dashboard/account-check',
        title: 'Account Check',
        loadComponent: () =>
            import('app/products/bi/dashboards/data-control/account-check/account-check.component').then(
                m => m.AccountCheckComponent
            ),
    },

    // Score Cards
    {
        path: 'dashboard/one-pager',
        title: 'One Pager',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/score-cards/one-pager/one-pager.component').then(
                m => m.OnePagerComponent
            ),
    },
    {
        path: 'dashboard/hygiene-factors',
        title: 'Hygiene Factors',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/score-cards/score-card/score-card.component').then(
                m => m.ScoreCardComponent
            ),
    },

    // Upselling
    {
        path: 'dashboard/upselling',
        title: 'Upsell at Check-in',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/upselling/up-checkin/up-check-in.component').then(
                m => m.UpsellingCheckInComponent
            ),
    },
    {
        path: 'dashboard/upselling-brandweb',
        title: 'Brandweb Upsell',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/upselling/up-brandweb/up-brandweb.component').then(
                m => m.UpsellingBrandwebComponent
            ),
    },
    {
        path: 'dashboard/gm-comments',
        title: 'GM Comments',
        canActivate: [productGuard('insight')],
        loadComponent: (): any =>
            import('app/products/bi/dashboards/revops/gm-comments/gm-comments.component').then(
                m => m.GMCommentsComponent
            ),
    },

    // Commercial Plan
    {
        path: 'dashboard/cp-overview',
        title: 'ommercial Plan Overview',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/commercial-plan/overview/cp-overview.component').then(
                m => m.CommercialPlanOverviewComponent
            ),
    },
    {
        path: 'dashboard/cp-activity-plan',
        title: 'Commercial Plan Activity Plan',
        canActivate: [productGuard('insight')],
        loadComponent: () =>
            import('app/products/bi/dashboards/commercial-plan/activity-plan/cp-activity-plan.component').then(
                m => m.CommercialPlanActivityPlanComponent
            ),
    },
    {
        path: 'dashboard/cp-corporate',
        title: 'Commercial Plan Corporate',
        canActivate: [productGuard('insight')],
        loadComponent: (): any =>
            import('app/products/bi/dashboards/commercial-plan/corporate/cp-corporate.component').then(
                m => m.CommercialPlanCorporateComponent
            ),
    },
    {
        path: 'dashboard/cp-tmc',
        title: 'Commercial Plan TMC',
        canActivate: [productGuard('insight')],
        loadComponent: (): any =>
            import('app/products/bi/dashboards/commercial-plan/tmc/cp-tmc.component').then(
                m => m.CommercialPlanTmcComponent
            ),
    },
    {
        path: 'dashboard/cp-bgr',
        title: 'Commercial Plan BGR',
        canActivate: [productGuard('insight')],
        loadComponent: (): any =>
            import('app/products/bi/dashboards/commercial-plan/bgr/cp-bgr.component').then(
                m => m.CommercialPlanBgrComponent
            ),
    },
    {
        path: 'dashboard/cp-me',
        title: 'Commercial Plan M&E',
        canActivate: [productGuard('insight')],
        loadComponent: (): any =>
            import('app/products/bi/dashboards/commercial-plan/me/cp-me.component').then(
                m => m.CommercialPlanMeComponent
            ),
    },
    {
        path: 'dashboard/cp-bgo',
        title: 'Commercial Plan BGO',
        canActivate: [productGuard('insight')],
        loadComponent: (): any =>
            import('app/products/bi/dashboards/commercial-plan/bgo/cp-bgo.component').then(
                m => m.CommercialPlanBgoComponent
            ),
    },
    {
        path: 'dashboard/cp-lgr',
        title: 'Commercial Plan LGR',
        canActivate: [productGuard('insight')],
        loadComponent: (): any =>
            import('app/products/bi/dashboards/commercial-plan/lgr/cp-lgr.component').then(
                m => m.CommercialPlanLgrComponent
            ),
    },
    {
        path: 'dashboard/cp-crew',
        title: 'Commercial Plan CREW',
        canActivate: [productGuard('insight')],
        loadComponent: (): any =>
            import('app/products/bi/dashboards/commercial-plan/crew/cp-crew.component').then(
                m => m.CommercialPlanCrewComponent
            ),
    },
];
